import Model from "./base/model";

class fileViewPath extends Model {
  resourceName() {
    return "file_view_path";
  }

  fields() {
    return {
      file_path: "",
      temporary_file_path: "",
    }
  }

  async getTemporaryUrl(filePath) {
    return this.request(
      "invoice/" + this.resourceName(),
      "POST",
      {},
      {file_path: filePath},
    );
  }


}

export default new fileViewPath();
